<template>
    <page>
		<module enable-flex>
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="分类中名称"
					name="product_type_name"
					expand-limit="2"
					width="250"
					@expand="loadChildren"
				>
				</c-table-column>

                <c-table-column
                    label="分类英名称"
                    name="product_type_name_en"
                    width="200"
                ></c-table-column>

                <c-table-column label="选中图标" width="80">
                    <template #default="{data}">
                        <div v-if="data.product_type_icon_checked" class="group-img flex-center">
                            <img :src="data.product_type_icon_checked" alt="" width="50">
                        </div>
                    </template>
                </c-table-column>

                <c-table-column label="未选中图标" width="80">
                    <template #default="{data}">
                        <div v-if="data.product_type_icon" class="group-img flex-center">
                            <img :src="data.product_type_icon" alt="" width="50">
                        </div>
                    </template>
                </c-table-column>

<!--				<c-table-column
					type="sort"
					label="排序"
					@sort="sortHandle"
				></c-table-column>-->
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="110"
				>
					<template v-slot="row">
						<c-table-button power="b_product_type_edit" @click="editHandle(row)">编辑</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="dialog" :title="classifyEditTitle" width="800" height="450" @resolve="addChild">
			<c-form ref="classifyEdit">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="分类中名称" name="product_type_name" required></c-form-item>
				<c-form-item type="input" label="分类英名称" name="product_type_name_en" required></c-form-item>
                <c-form-item v-if="editLevel == 0" type="image" label="未选中图标" name="product_type_icon"  file-word="建议尺寸: 120*120px；支持jpg，jpeg，png格式" required></c-form-item>
                <c-form-item v-if="editLevel == 0" type="image" label="选中图标" name="product_type_icon_checked" file-word="建议尺寸: 120*120px；支持jpg，jpeg，png格式" required></c-form-item>
            </c-form>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_product_type',
		
		data() {
			return {
				editState: false,
                classifyEditTitle:'编辑分类',
                editLevel:-1         //当前所属分类等级
			}
		},
        computed: {
        },
		mounted() {
			this.$refs.table.load({
				url: '/product/type/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/product/type/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data || []);
					}
				});
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: '/product/type/sort',
					data: {
						id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
						next();
					}
				});
			},
            //编辑弹窗
            editHandle(row) {
                this.editState = true;
                this.editLevel = row.expandData.level;
                this._edit = row.data.id;
                this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
                this._resolve = data => {
                    row.update(data);
                };
                this.classifyEditTitle = '编辑分类【'+row.data.product_type_name+'】';
                this.$refs.classifyEdit.set(row.data);
                this.$refs.dialog.open();
            },
            //提交编辑数据
			addChild(stop) {
				stop();
                this.$refs.classifyEdit.submit({
                    url: this._edit ? '/product/type/edit' : '/product/type/add',
                    rule: {
                        product_type_name:'请填写分类中名称',
                        product_type_name_en:'请填写分类英名称',
                        product_type_icon:[{
                            type:'empty',
                            skip: () => {
                                return this.editLevel > 0;
                            },
                            word: '请上传分类未选中的icon图标'
                        }],
                        product_type_icon_checked:[{
                            type:'empty',
                            skip: () => {
                                return this.editLevel > 0;
                            },
                            word: '请上传分类被选中的icon图标'
                        }]
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                        this.$refs.dialog.close();
                        this._resolve(data);
                    }
                });
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.spec {
		position: relative;
		padding: 15px 17px;
		background: #F9F8FB;
		
		&:nth-child(n+2) {
			margin-top: 16px;
		}
		
		&-list {
			.c-button {
				margin-top: 16px;
			}
		}
		
		&-label {
			margin-right: 8px;
			line-height: 36px;
			font-size: 13px;
			white-space: nowrap;
			color: #444;
		}
		
		&-handle {
			position: absolute;
			right: 0;
			top: 0;
		
			&-item {
				width: 24px;
				margin-left: 5px;
				line-height: 24px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				background: #aaa;
				
				&:hover {
					background: #999;
				}
			}
		}
		
		&-name {
			width: 130px;
			height: 34px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: 14px;
			font-size: 13px;
			background: #fff;
		}
		
		&-item {
			width: 128px;
			height: 30px;
			border: 1px solid #ddd;
			padding: 0 5px;
			margin-top: 12px;
			margin-right: 12px;
			background: #fff;
			
			&-value {
				font-size: 13px;
			}
			
			&-remove {
				margin-left: 5px;
				font-size: 16px;
				color: #C70000;
			}
		}
		
		.c-button {
			margin-top: 16px;
		}
	}
</style>